import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopMenu from "./TopMenu";
import AppShellScrollLock from "./AppShellScrollLock";
import { shouldShowTopChrome } from "util/showTopChrome";

/**
 * Top chrome must follow react-router location. App is a connect() class
 * component and does not re-render on client navigations, so showTopChrome
 * was frozen after /login or ?email= and TopMenu never mounted again until
 * a full refresh.
 */
const AppViewportShell = ({ authenticated, user, theme, children }) => {
  const location = useLocation();
  const showTopChrome = shouldShowTopChrome(
    location.pathname,
    location.search || ""
  );

  useEffect(() => {
    try {
      document.documentElement.dataset.pivonyTopChrome = showTopChrome
        ? "1"
        : "0";
      document.documentElement.dataset.pivonyPath = location.pathname || "";
    } catch (_) {}
  }, [showTopChrome, location.pathname]);

  return (
    <div className={`App${showTopChrome ? " appShellViewport" : ""}`}>
      {showTopChrome ? (
        <>
          <AppShellScrollLock />
          <TopMenu authenticated={authenticated} user={user} theme={theme} />
        </>
      ) : null}
      <div className={showTopChrome ? "appRouterOutlet" : undefined}>
        {children}
      </div>
    </div>
  );
};

export default AppViewportShell;
